<app-header></app-header>

<div class="container-fluid" style="width: 80%;  min-height: 600px">

    <div class="row mt-4 mb-4">
        <div class="col">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
                <ol class="breadcrumb mb-0 p-0">
                    <li class="breadcrumb-item"><a href="/home">Home</a></li>
                </ol>
            </nav>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col">
            <h4>Home</h4>
        </div>
    </div>

    @if (centraliCotLoading) {
        <div class="row mb-3">
            <div class="col">
                <mat-card appearance="outlined">
                    <mat-card-content class="d-flex align-items-center gap-2">
                        <mat-spinner diameter="24"></mat-spinner>
                        <span>Caricamento centrali COT...</span>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    } @else if (centraliCot.length > 0) {
        <div class="row mb-4">
            <div class="col">
                <mat-card appearance="outlined" class="card-centrali-cot">
                    <mat-card-header>
                        <mat-card-title>Le tue centrali COT</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <p class="mb-0">{{ centraliCotDescrizioni }}</p>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    }

    <div class="row">
        @for (card of mainCards; track card.id) {
            @if (canShowCard(card)) {
                <div class="col-12 col-md-6 col-lg-3 mb-3">
                    <mat-card appearance="outlined">
                        <mat-card-header>
                            <mat-card-title class="card-title-with-icon">
                                @if (card.icon) {
                                    <mat-icon [fontIcon]="card.icon" class="card-title-icon"></mat-icon>
                                }
                                <span>{{ card.title }}</span>
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-actions>
                            @if (card.type === 'routerLink' && card.link) {
                                <a [routerLink]="card.link" mat-button [disabled]="isCardButtonDisabled(card)">{{ card.buttonLabel }}</a>
                            } @else if (card.type === 'href' && card.link) {
                                <a [href]="card.link" mat-button [disabled]="isCardButtonDisabled(card)">{{ card.buttonLabel }}</a>
                            } @else if (card.type === 'button' && card.id === 'richiesta-valutazione') {
                                <button mat-button (click)="apriRichiestaValutazione()">{{ card.buttonLabel }}</button>
                            } @else {
                                <button mat-button [disabled]="isCardButtonDisabled(card)">{{ card.buttonLabel }}</button>
                            }
                        </mat-card-actions>
                    </mat-card>
                </div>
            }
        }
    </div>

    @if (hasVisibleAdminCards) {
        <div class="row mt-4 pt-3 border-top">
            <div class="col-12 mb-2">
                <h5 class="text-muted">Amministrazione</h5>
            </div>
            @for (card of adminCards; track card.id) {
                @if (canShowCard(card)) {
                    <div class="col-12 col-md-6 col-lg-3 mb-3">
                        <mat-card appearance="outlined">
                            <mat-card-header>
                                <mat-card-title class="card-title-with-icon">
                                    @if (card.icon) {
                                        <mat-icon [fontIcon]="card.icon" class="card-title-icon"></mat-icon>
                                    }
                                    <span>{{ card.title }}</span>
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-actions>
                                @if (card.type === 'routerLink' && card.link) {
                                    <a [routerLink]="card.link" mat-button [disabled]="isCardButtonDisabled(card)">{{ card.buttonLabel }}</a>
                                } @else if (card.type === 'href' && card.link) {
                                    <a [href]="card.link" mat-button [disabled]="isCardButtonDisabled(card)">{{ card.buttonLabel }}</a>
                                } @else if (card.type === 'button' && card.id === 'richiesta-valutazione') {
                                    <button mat-button (click)="apriRichiestaValutazione()">{{ card.buttonLabel }}</button>
                                } @else {
                                    <button mat-button [disabled]="isCardButtonDisabled(card)">{{ card.buttonLabel }}</button>
                                }
                            </mat-card-actions>
                        </mat-card>
                    </div>
                }
            }
        </div>
    }

</div>






<app-footer></app-footer>